// extracted by mini-css-extract-plugin
module.exports = {"button":"EventCardBlock_button___Xp_4","card":"EventCardBlock_card__f1RiJ"};